<div
  [ngClass]="{
    'blank-page':
      router.url === '/authentication/internal-error' ||
      router.url === '/authentication/reset-password' ||
      router.url === '/authentication/forgot-password' ||
      router.url.startsWith('/authentication/login') ||
      router.url === '/authentication/register' ||
      router.url === '/authentication/logout' ||
      router.url === '/authentication/confirm-mail' ||
      router.url === '/authentication/not-found' ||
      router.url === '/authentication/lock-screen' ||
      router.url === '/coming-soon'
  }"
  [class.dark-theme]="themeService.isDark()"
  [class.card-borderd-theme]="themeService.isCardBorder()"
  [class.card-border-radius]="themeService.isCardBorderRadius()"
  [class.rtl-enabled]="themeService.isRTLEnabled()"
>
  <core-sidebar></core-sidebar>
  <div class="main-content d-flex flex-column" [ngClass]="{ active: isToggled }" [class.right-sidebar]="themeService.isRightSidebar()" [class.hide-sidebar]="themeService.isHideSidebar()">
    <app-header></app-header>
    <router-outlet></router-outlet>
    <div class="flex-grow-1"></div>
    <app-footer></app-footer>
  </div>
</div>
<block-ui> </block-ui>
